import React, {useState, useEffect} from 'react'
import classes from './BottomAppBar.module.css'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChild, faComment,
    faHome,
    faPlus, faSearch, faStickyNote,
    faThLarge,
} from "@fortawesome/free-solid-svg-icons";
import {Trans} from "react-i18next";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {SUPPORTED_FUNCTIONS} from "../../Utils/FunctionList";

const BottomAppBar = (props) => {

    return (
        <div className={classes.BottomAppBar}>
            <div className={classes.IconContainer}>
                <Link to={{
                    pathname: "/",
                    state: {auth: props.auth}
                }}>
                    <div className={classes.FunctionBtnContainer}>
                        <button
                            aria-label
                            alt={'home page'}
                            className={window.location.pathname === '/' ? classes.FunctionBtnSelected : classes.FunctionBtn}>
                            <FontAwesomeIcon icon={faHome}/>
                        </button>
                        <span
                            className={window.location.pathname === '/' ? classes.FunctionBtnDescriptionSelect : classes.FunctionBtnDescription}>
                                 <Trans>LeftNavBar.homepage</Trans>
                            </span>
                    </div>
                </Link>
            </div>
            <div className={classes.IconContainer}>
                <Link to={{
                    pathname: "/list",
                    state: {auth: props.auth}
                }}>
                    <div className={classes.FunctionBtnContainer}>
                        <button
                            aria-label
                            alt={'mewe category'}
                            className={window.location.pathname.includes("/list") ? classes.FunctionBtnSelected : classes.FunctionBtn}>
                            <FontAwesomeIcon icon={faThLarge}/>
                        </button>
                        <span
                            className={window.location.pathname.includes("/list") ? classes.FunctionBtnDescriptionSelect : classes.FunctionBtnDescription}>
                                 <Trans>LeftNavBar.list-category</Trans>
                            </span>
                    </div>
                </Link>
            </div>
            <div className={classes.IconContainer}>
                <Link to={{
                    pathname: "/about",
                    state: {auth: props.auth}
                }}>
                    <button
                        aria-label
                        alt={'mewe category'}
                        className={window.location.pathname.includes("/about") ? classes.FunctionBtnSelected : classes.FunctionBtn}>
                        <FontAwesomeIcon icon={faChild}/>
                    </button>
                    <span
                        className={window.location.pathname.includes("/about") ? classes.FunctionBtnDescriptionSelect : classes.FunctionBtnDescription}>
                                 <Trans>LeftNavBar.about-us</Trans>
                            </span>
                </Link>
            </div>

            <div className={classes.IconContainer}>
                <Link to={{
                    pathname: "/tips",
                    state: {auth: props.auth}
                }}>
                    <div className={classes.FunctionBtnContainer}>
                        <button
                            aria-label
                            alt={'go to portal after login'}
                            className={window.location.pathname.includes("/tips") ? classes.FunctionBtnSelected : classes.FunctionBtn}>
                            <FontAwesomeIcon icon={faStickyNote}/>

                        </button>
                        <span
                            className={window.location.pathname.includes("/tips") ? classes.FunctionBtnDescriptionSelect : classes.FunctionBtnDescription}>
                                 <Trans>LeftNavBar.tips</Trans>
                            </span>
                    </div>
                </Link>
            </div>


            <div className={classes.IconContainer}>
                <div className={classes.FunctionBtnContainer}>
                    <button
                        aria-label
                        alt={'feedback'}
                        onClick={() => {
                            props.setModalController({
                                type: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                typeOfModal: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                isModalOpen: true,
                                metadata: {itemID: "feedback homepage"}
                            })
                        }}
                        className={classes.FunctionBtn}>
                        <FontAwesomeIcon icon={faComment}/>

                    </button>
                    <span
                        className={classes.FunctionBtnDescription}>
                                 <Trans>BottomApp.feedback</Trans>
                            </span>
                </div>
            </div>

            <div className={classes.IconContainer}>
                <Link to={{
                    pathname: "/search",
                }}>
                    <div className={classes.FunctionBtnContainer}>
                        <button
                            aria-label
                            alt={'go to portal after login'}
                            className={window.location.pathname.includes("/search") ? classes.FunctionBtnSelected : classes.FunctionBtn}>
                            <FontAwesomeIcon icon={faSearch}/>

                        </button>
                        <span
                            className={window.location.pathname.includes("/search") ? classes.FunctionBtnDescriptionSelect : classes.FunctionBtnDescription}>
                                 <Trans>LeftNavBar.search</Trans>
                            </span>
                    </div>
                </Link>
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        setModalController: (state) => dispatch({
            type: state.type,
            typeOfModal: state.typeOfModal,
            isModalOpen: state.isModalOpen,
            metadata: state.metadata
        })
    }
}

const mapStateToProps = state => {
    return {
        auth: state.firebase.auth
    }

}

const enhance = connect(
    mapStateToProps,
    mapDispatchToProps
)

export default enhance(withRouter(BottomAppBar))